import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEprProducerStatus implements BaseEnumType {
  private static allValues: EnumEprProducerStatus[] = []; // make sure this is top-most
  
  public static none = new EnumEprProducerStatus(0, "None", "enum_epr_producer_status_none");
  public static smallProducer = new EnumEprProducerStatus(1, "SmallProducer", "enum_epr_producer_status_small_producer");
  public static largeProducer = new EnumEprProducerStatus(2, "LargeProducer", "enum_epr_producer_status_large_producer");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEprProducerStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumEprProducerStatus.none; }
  public isSmallProducer() { return this === EnumEprProducerStatus.smallProducer; }
  public isLargeProducer() { return this === EnumEprProducerStatus.largeProducer; }

  public static getValues(): readonly EnumEprProducerStatus[] {
    return EnumEprProducerStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumEprProducerStatus[] {
    return EnumEprProducerStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEprProducerStatus {
    const found = EnumEprProducerStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEprProducerStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEprProducerStatus): EnumEprProducerStatus {
    const found = name ? EnumEprProducerStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEprProducerStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEprProducerStatus>): boolean {
    return this.key === other?.key;
  }
}